<template>
    <div class="language-select">
        <button class="flag flag-ru" @click="chooseLanguage('ru')"></button>
        <button class="flag flag-us" @click="chooseLanguage('en')"></button>
    </div>
</template>

<script>
  export default {
    name: 'language',
    methods: {
      chooseLanguage (lang) {
        localStorage.setItem('lang', lang)
        window.location.reload()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Language.vue?db089e7e